import styled from 'styled-components'
interface Props {
  isBadges?: boolean ,
  text?:  string,
}
const notBadgeColor = "#039F5E"
const isBadgesColor = "#FEA41E"

const Ribbon = styled.div<Props>`
    -webkit-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
    transform: rotate(-45deg);
    border: 25px solid transparent;
    border-bottom: 25px solid ${(props)=>props.isBadges ? isBadgesColor : notBadgeColor};
    position: absolute;
    padding: 0 10px;
    width: 120px;
    color: #fff;
    size: 11px;
    top: 0;
    left: -36px;
    display: flex;
    &::after{
    content: ${({ text="" }) => `"${text}"`};
    position: absolute;
    color: white;
    font-weight: 400;
    text-align:center;
    font-size: 14px;
    padding: 3px 0px;
    display:inline-block;
    margin: 0px auto;
    left:50%;
    transform:translateX(-50%);
  }
 white-space: nowrap;
 @media (max-width: 750px) {
   &::after{
    font-size: 11px;
  }
   border: 21px solid transparent;
   border-bottom: 21px solid ${(props)=>props.isBadges ? isBadgesColor : notBadgeColor};
   width: 70px;
   top: -11px;
    left: -25px;

    }
    @media(min-width: 780px){
      width:100px;
      left:-32px;
      top: -7px;
    }
`;

export default Ribbon;
